import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  ja: {
    translation: {
      nav: {
        home: 'ホーム',
        funds: 'ファンド',
        dashboard: 'ダッシュボード',
        login: 'ログイン',
        register: '無料登録',
        logout: 'ログアウト',
        myPage: 'マイページ',
        admin: '管理者パネル'
      },
      hero: {
        title: '不動産投資を、もっとシンプルに、もっと透明に。',
        subtitle: 'Presage REIT\'s Control は、投資・分配・管理のすべてを可視化するグローバル投資プラットフォームです。',
        cta1: '無料で始める',
        cta2: 'ファンドを見る',
        cta3: 'デモを見る'
      },
      steps: {
        title: '3ステップで始める投資',
        step1: { title: '登録', desc: '簡単な情報入力で、すぐにアカウント作成' },
        step2: { title: '本人確認', desc: 'オンラインで完結するKYC認証' },
        step3: { title: '投資開始', desc: '好みのファンドを選んで投資' }
      },
      features: {
        title: '選ばれる理由',
        transparency: { title: '分配の透明性', desc: '収益・コスト・純利益の計算式をそのまま表示' },
        global: { title: 'グローバル対応', desc: '多言語・海外送金に完全対応' },
        dashboard: { title: '意思決定支援UI', desc: '一画面でわかる資産状況とリアルタイム分析' },
        security: { title: '万全のセキュリティ', desc: 'KYC・暗号化・監査ログ・不正検知AI' }
      },
      funds: {
        title: 'ファンド一覧',
        viewAll: 'すべて見る',
        minInvestment: '最低投資額',
        targetYield: '想定利回り',
        actualYield: '実績利回り',
        riskLevel: 'リスク',
        totalRaised: '調達額',
        invest: '投資する',
        low: '低',
        medium: '中',
        high: '高',
        guaranteed: '利息保証あり',
        details: '詳細を見る',
        investNow: '投資する',
        backToFunds: 'ファンド一覧に戻る',
        fundInfo: 'ファンド情報',
        propertyType: '物件タイプ',
        location: '所在地',
        status: 'ステータス',
        guaranteeInfo: '保証情報',
        guaranteeType: '保証タイプ',
        guaranteeRate: '保証利回り',
        guaranteePeriod: '保証期間',
        guaranteeConditions: '保証条件',
        guaranteeFull: '全額保証',
        guaranteePartial: '一部保証',
        guaranteeNone: 'なし',
        riskWarning: 'リスクに関する注意事項',
        riskWarningText: '投資にはリスクが伴います。元本保証はありません。投資判断は自己責任で行ってください。',
        searchPlaceholder: 'ファンドを検索...',
        allRisks: 'すべてのリスク',
        sortBy: '並び替え',
        riskLevelFilter: 'リスクレベル'
      },
      distribution: {
        title: '分配の透明性',
        subtitle: '計算式をそのまま表示。見える投資を実現。',
        grossRevenue: '総収益',
        costs: 'コスト',
        netProfit: '純利益',
        yourShare: 'あなたの持分',
        yourDistribution: 'あなたの分配金'
      },
      transfer: {
        title: '送金方法',
        subtitle: '安全で低コストな国際送金',
        wise: { title: 'Wise', desc: '低手数料・リアルタイムレート' },
        prc: { title: 'PRC Remit', desc: '新興国送金に強い' },
        note: '※ 送金手数料・為替レートは各サービスの条件に準じます'
      },
      stats: {
        totalFunds: 'ファンド数',
        totalRaised: '総調達額',
        investors: '投資家数',
        avgYield: '平均利回り',
        oku: '億'
      },
      security: {
        title: 'セキュリティ',
        kyc: 'KYC本人確認',
        encryption: 'データ暗号化',
        audit: '監査ログ',
        ai: '不正検知AI'
      },
      faq: {
        title: 'よくある質問',
        q1: '最低投資額はいくらですか？',
        a1: 'ファンドにより異なりますが、最低30,000円から投資可能です。',
        q2: '元本は保証されますか？',
        a2: '原則として元本保証はありません。ただし、一部の低利回りファンドには条件付きの利息保証があります。',
        q3: '分配金はいつ受け取れますか？',
        a3: '四半期ごと（3月、6月、9月、12月）に分配を行います。',
        q4: '出金にはどれくらいかかりますか？',
        a4: '出金申請から3-5営業日で処理されます。'
      },
      cta: {
        title: '今すぐ始めましょう',
        subtitle: '透明な投資体験を、あなたに。',
        button: '無料で始める'
      },
      dashboard: {
        title: 'ダッシュボード',
        totalAssets: '総資産',
        totalYield: '利回り',
        totalDistributions: '累計分配金',
        profitLoss: '損益',
        assetHistory: '資産推移',
        distributionHistory: '分配履歴',
        myInvestments: '保有ファンド',
        noInvestments: 'まだ投資がありません',
        startInvesting: '投資を始める',
        rankings: 'ランキング',
        highYield: '高利回り',
        popular: '人気',
        deposit: '入金',
        withdraw: '出金',
        invest: '投資する',
        man: '万'
      },
      auth: {
        login: 'ログイン',
        register: '新規登録',
        email: 'メールアドレス',
        password: 'パスワード',
        name: 'お名前',
        namePlaceholder: '山田太郎',
        language: '言語',
        loginButton: 'ログイン',
        registerButton: '登録する',
        noAccount: 'アカウントをお持ちでない方',
        hasAccount: 'すでにアカウントをお持ちの方',
        forgotPassword: 'パスワードを忘れた方'
      },
      kyc: {
        title: '本人確認',
        required: 'KYC認証が必要です',
        description: '投資・出金には本人確認が必要です。',
        start: '本人確認を開始',
        pending: '確認中',
        verified: '確認済み',
        selectDocument: '書類タイプを選択',
        passport: 'パスポート',
        driverLicense: '運転免許証',
        idCard: 'マイナンバーカード / 在留カード',
        completed: '本人確認が完了しました。ファンドへの投資が可能です。',
        goToFunds: 'ファンド一覧へ',
        stepSelect: '書類選択',
        stepReview: '審査中',
        stepDone: '完了',
        reviewing: '審査中',
        reviewingDesc: '提出された書類を管理者が確認中です。通常1-2営業日以内に完了します。',
        reviewingNote: '結果はダッシュボードでご確認いただけます。',
        rejected: '本人確認が却下されました',
        rejectedReason: '理由: {{reason}}',
        rejectedRetry: '書類を再度提出してください。',
        uploadDoc: '書類をアップロード',
        clickToSelect: 'クリックしてファイルを選択',
        fileTypes: 'JPG, PNG, PDF (最大10MB)',
        fileTypeError: 'JPG, PNG, PDF ファイルのみアップロード可能です',
        fileSizeError: 'ファイルサイズは10MB以下にしてください',
        uploadError: '提出に失敗しました',
        uploadSuccess: '書類を提出しました。管理者の確認をお待ちください。',
        pleaseUpload: '書類をアップロードしてください',
        notice: '書類の文字が鮮明に読み取れることを確認してください。提出後、管理者が1-2営業日以内に確認します。',
        submitting: '送信中...',
        submit: '書類を提出',
        secureComm: '安全な暗号化通信',
        fastReview: '1-2営業日で完了',
        oneTime: '一度のみの手続き'
      },
      contact: {
        title: 'お問い合わせ',
        subtitle: 'ご質問・ご要望をお聞かせください',
        name: 'お名前',
        namePlaceholder: '山田太郎',
        email: 'メールアドレス',
        subject: '件名',
        subjectPlaceholder: 'お問い合わせの件名',
        message: 'メッセージ',
        messagePlaceholder: 'お問い合わせ内容をご記入ください...',
        sending: '送信中...',
        send: '送信する',
        success: 'お問い合わせを送信しました',
        error: '送信に失敗しました',
        doneTitle: '送信完了',
        doneMessage: 'お問い合わせありがとうございます。',
        doneNote: '内容を確認の上、ご連絡いたします。',
        backHome: 'ホームに戻る'
      },
      deposit: {
        title: '入金依頼',
        subtitle: '入金依頼を提出してください。管理者が確認後、残高に反映されます。',
        refNumber: 'あなたの参照番号（必ず記載してください）',
        copied: 'コピーしました',
        fees: '手数料',
        feesDesc: '送金額の {{percentage}}%（最低 {{minimum}}円）',
        bankInfo: '送金先情報',
        bankName: '銀行名',
        refNumberLabel: '参照番号',
        steps: '送金手順',
        currencies: '対応通貨',
        exchangeRates: '現在の為替レート（参考）',
        rateUpdated: '更新: {{date}}',
        rateNote: '※ 1円あたりのレート。実際のレートは送金サービスにより異なります。',
        warnings: '注意事項',
        needRegister: '入金には会員登録が必要です',
        registerFree: '無料で会員登録',
        requestTitle: '入金依頼',
        amount: '入金額（円）',
        amountPlaceholder: '例: 1000000',
        method: '入金方法',
        methodBank: '銀行振込',
        methodWise: 'Wise送金',
        depositorName: '振込名義',
        depositorNamePlaceholder: '振込人のお名前',
        notesLabel: '備考',
        notesPlaceholder: '振込日時やその他の情報（任意）',
        submit: '入金依頼を送信',
        submitting: '送信中...',
        success: '入金依頼を送信しました',
        error: '送信に失敗しました',
        history: '入金履歴',
        noDeposits: '入金履歴はありません',
        statusPending: '確認待ち',
        statusApproved: '承認済',
        statusRejected: '却下',
        balance: '残高',
        balanceDesc: '入金が承認されると残高に反映されます',
        enterAmount: '金額を入力してください',
        enterDepositorName: '振込名義を入力してください',
        methodInfoTitle: '送金先情報',
        methodAccountName: '口座名義',
        methodAccountEmail: 'メール',
        methodAccountId: '口座ID',
        methodCurrency: '通貨',
        methodFee: '手数料'
      },
      withdrawal: {
        title: '出金申請',
        subtitle: '評価額ベースで出金できます',
        available: '出金可能額',
        selectAmount: '出金額と方法を選択',
        amount: '出金額（円）',
        minAmount: '最低出金額: ¥10,000',
        method: '出金方法',
        currency: '受取通貨',
        calculating: '計算中...',
        calculate: '計算する',
        confirm: '出金内容の確認',
        amountLabel: '出金額',
        fee: '手数料（{{percentage}}%）',
        afterFee: '手数料控除後',
        exchangeRate: '為替レート',
        expectedAmount: '受取予定額',
        bankInfo: '銀行口座情報',
        bankName: '銀行名 *',
        bankNamePlaceholder: '三菱UFJ銀行',
        accountName: '口座名義 *',
        accountNamePlaceholder: 'ヤマダ タロウ',
        accountNumber: '口座番号 *',
        swiftCode: 'SWIFT/BICコード',
        notes: '備考（支店名など）',
        notesPlaceholder: '渋谷支店 普通',
        submitting: '申請中...',
        submitBtn: '出金を申請する',
        doneTitle: '出金申請完了',
        doneMessage: '出金申請を受け付けました。',
        doneNote: '処理には3-5営業日かかります。',
        backDashboard: 'ダッシュボードに戻る',
        history: '出金履歴',
        needKyc: 'KYC認証が必要です',
        needKycDesc: '出金には本人確認が必要です。',
        startKyc: '本人確認を行う',
        inputError: '出金額を入力してください',
        calcError: '計算に失敗しました',
        bankError: '銀行情報を入力してください',
        success: '出金申請を受け付けました',
        error: '申請に失敗しました',
        statusPending: '処理中',
        statusApproved: '承認済',
        statusCompleted: '完了',
        statusRejected: '拒否',
        wiseOption: 'Wise（手数料 {{fee}}%）',
        prcOption: 'PRC Remit（手数料 {{fee}}%）',
        jpyOption: 'JPY（日本円）',
        usdOption: 'USD（米ドル）',
        brlOption: 'BRL（ブラジルレアル）',
        eurOption: 'EUR（ユーロ）',
        gbpOption: 'GBP（ポンド）',
        feeLabel: '手数料（{{percentage}}%）',
        swiftLabel: 'SWIFT/BICコード',
        completedText: '出金申請を受け付けました。',
        processingText: '処理には3-5営業日かかります。'
      },
      content: {
        notFound: 'ページが見つかりません',
        backHome: 'ホームに戻る',
        back: '戻る',
        lastUpdated: '最終更新: {{date}}'
      },
      footer: {
        terms: '利用規約',
        privacy: 'プライバシーポリシー',
        contact: 'お問い合わせ',
        company: '会社概要',
        risk: 'リスク説明',
        copyright: '© 2024 Presage Ltd. All rights reserved.'
      },
      admin: {
        dashboard: '管理者ダッシュボード',
        users: 'ユーザー管理',
        funds: 'ファンド管理',
        pages: 'ページ管理',
        menus: 'メニュー管理',
        menuCat: 'ヘッダーメニュー',
        contacts: 'お問い合わせ',
        withdrawals: '出金管理',
        deposits: '入金管理',
        distributions: '分配管理',
        kyc: 'KYC審査',
        auditLogs: '監査ログ',
        noContacts: 'お問い合わせはありません',
        noUsers: '該当するユーザーがいません',
        noLogs: 'ログがありません',
        createUser: '新規ユーザー作成',
        userDetail: 'ユーザー詳細',
        resetPassword: 'パスワードリセット',
        searchUser: '名前またはメールで検索...',
        allRoles: '全ロール',
        allKyc: '全KYC',
        allStatus: '全状態',
        active: '有効',
        inactive: '無効',
        roleAdmin: '管理者',
        roleUser: 'ユーザー',
        verified: '認証済み',
        pending: '審査中',
        notStarted: '未提出',
        rejected: '却下',
        name: '名前',
        email: 'メール',
        role: 'ロール',
        kycLabel: 'KYC',
        status: '状態',
        registeredAt: '登録日',
        actions: '操作',
        deleteUser: 'ユーザーを削除',
        deleteConfirm: 'を削除しますか？この操作は取り消せません。',
        investCount: '投資件数',
        totalInvested: '総投資額',
        totalDist: '総分配額',
        investments: '投資一覧',
        distHistory: '分配履歴',
        withdrawHistory: '出金履歴',
        noTransactions: '取引履歴がありません',
        fund: 'ファンド',
        amount: '投資額',
        currentValue: '現在価値',
        distAmount: '分配額',
        date: '日付',
        method: '方法',
        passwordLabel: 'パスワード（8文字以上）',
        creating: '作成中...',
        create: '作成',
        newPassword: '新しいパスワード（8文字以上）',
        resetting: 'リセット中...',
        reset: 'リセット',
        resetDesc: 'のパスワードをリセットします。',
        all: '全て',
        authCat: '認証',
        fundCat: 'ファンド',
        userCat: 'ユーザー',
        kycCat: 'KYC',
        withdrawCat: '出金',
        depositCat: '入金',
        distCat: '分配',
        settingsCat: '設定',
        datetime: '日時',
        category: 'カテゴリ',
        action: '操作',
        executor: '実行者',
        details: '詳細',
        items: '件',
        fetchError: 'データの取得に失敗しました',
        userFetchError: 'ユーザー情報の取得に失敗しました',
        fillAllFields: '全てのフィールドを入力してください',
        passwordMin: 'パスワードは8文字以上必要です',
        userCreated: 'ユーザーを作成しました',
        createFailed: '作成に失敗しました',
        passwordResetDone: 'パスワードをリセットしました',
        resetFailed: 'リセットに失敗しました',
        operationFailed: '操作に失敗しました',
        saved: '保存しました',
        saveFailed: '保存に失敗しました',
        logoUploaded: 'ロゴをアップロードしました',
        uploadFailed: 'アップロードに失敗しました',
        logoDeleted: 'ロゴを削除しました',
        deleteFailed: '削除に失敗しました',
        companySaved: '会社情報を保存しました',
        photoUploaded: '写真をアップロードしました',
        photoDeleted: '写真を削除しました',
        menuSaved: 'メニューを保存しました',
        slugRequired: 'スラッグとタイトルは必須です',
        pageCreated: 'ページを作成しました',
        contactReplied: '返信しました',
        replyFailed: '返信に失敗しました',
        noteSaved: 'メモを保存しました',
        statusUpdated: 'ステータスを更新しました',
        updateFailed: '更新に失敗しました',
        depositApproved: '入金を承認しました',
        depositRejected: '入金を却下しました',
        depositMethodsSaved: '入金方法を保存しました',
        fundSaved: 'ファンドを保存しました',
        fundDeleted: 'ファンドを削除しました',
        fundDeleteConfirm: 'このファンドを削除しますか？',
        kycApproved: 'KYCを承認しました',
        kycRejected: 'KYCを却下しました',
        distributionExecuted: '分配を実行しました',
        terms: '利用規約',
        privacy: 'プライバシーポリシー',
        risk: 'リスク説明',
        about: '会社概要',
        statusNew: '新規',
        statusRead: '確認済',
        statusReplied: '返信済',
        statusPendingW: '処理中',
        statusApprovedW: '承認済',
        statusCompleted: '完了',
        statusRejectedW: '拒否',
        statusPendingD: '確認待ち',
        statusApprovedD: '承認済',
        statusRejectedD: '却下',
        kycPending: '審査中',
        kycApprovedLabel: '承認',
        kycRejectedLabel: '却下',
        docPassport: 'パスポート',
        docLicense: '運転免許証',
        docIdCard: 'マイナンバーカード',
        detailTitle: '詳細',
        editTitle: '編集',
        resetPwTitle: 'パスワードリセット',
        disableTitle: '無効化',
        enableTitle: '有効化',
        deleteTitle: '削除',
        fundActive: '公開中',
        guaranteeFull: '全額保証',
        guaranteePartial: '一部保証',
        guaranteeExists: '保証あり',
        logoChange: '変更',
        logoUpload: 'アップロード',
        depositMethodsTitle: '入金方法の設定',
        depositMethodsDesc: 'ユーザーに表示する送金先情報を設定します',
        saveDepositMethods: '入金方法を保存',
        saving: '保存中...',
        noDeposits: '入金依頼はありません',
        noWithdrawals: '出金申請はありません',
        distExecuted: '実行済',
        kycDocError: '書類不備',
        newFund: '新規ファンド作成',
        editFund: 'ファンドを編集',
        withdrawalAccepted: '出金申請を受け付けました',
        withdrawalProcessing: '処理には3-5営業日かかります',
        accountName: '口座名義',
        accountEmail: 'メールアドレス',
        accountId: '口座ID / 口座番号',
        currency: '通貨',
        feeRate: '手数料率（%）',
        notes: '備考・案内文',
        auditActions: {
          user_login: 'ログイン',
          fund_created: 'ファンド作成',
          fund_updated: 'ファンド更新',
          fund_deleted: 'ファンド削除',
          user_updated: 'ユーザー更新',
          user_deleted: 'ユーザー削除',
          withdrawal_approved: '出金承認',
          withdrawal_rejected: '出金却下',
          withdrawal_completed: '出金完了',
          withdrawal_pending: '出金保留',
          distribution_executed: '分配実行',
          deposit_approved: '入金承認',
          deposit_rejected: '入金却下',
          deposit_methods_updated: '入金方法更新',
          kyc_approved: 'KYC承認',
          kyc_rejected: 'KYC却下',
          user_created: 'ユーザー作成',
          password_reset: 'パスワードリセット',
          status_toggled: '状態変更'
        },
        editUser: 'ユーザーを編集',
        basicInfo: '基本情報',
        targetYieldLabel: '想定利回り (%)',
        actualYieldLabel: '実績利回り (%)',
        minInvestLabel: '最低投資額 (円)',
        riskLevelLabel: 'リスクレベル',
        riskLow: '低',
        riskMedium: '中',
        riskHigh: '高',
        propertyTypeLabel: '物件タイプ',
        locationLabel: '所在地',
        fundStatusLabel: 'ステータス',
        statusPublic: '公開',
        statusPrivate: '非公開',
        statusClosed: '終了',
        interestGuarantee: '利息保証あり',
        guaranteeSettings: '保証条件設定',
        guaranteeTypeLabel: '保証タイプ',
        guaranteeNoneOpt: 'なし',
        guaranteePartialOpt: '一部保証',
        guaranteeFullOpt: '全額保証',
        guaranteeRateLabel: '保証利回り (%)',
        guaranteePeriodLabel: '保証期間',
        guaranteeConditionsLabel: '保証条件',
        guaranteeConditionsPlaceholder: '保証の適用条件、注意事項等を記載...',
        exampleYield: '例: 5.0',
        examplePeriod: '例: 2025/01 - 2027/12',
        imageUrl: '画像URL',
        fundNameLabel: 'ファンド名',
        descriptionLabel: '説明',
        newDistribution: '新規分配を作成',
        selectFund: 'ファンドを選択',
        distributionDate: '分配日',
        grossRevenue: '総収益 (円)',
        costsLabel: 'コスト (円)',
        memoLabel: 'メモ',
        optional: '任意',
        calculatingDist: '計算中...',
        previewDistribution: '分配をプレビュー',
        distributionPreview: '分配プレビュー',
        previewFund: 'ファンド:',
        previewRevenue: '総収益:',
        previewCosts: 'コスト:',
        previewNetProfit: '純利益:',
        previewInvestors: '投資家数:',
        peopleSuffix: '名',
        previewTotal: '分配総額:',
        investorBreakdown: '投資家別分配内訳：',
        executingDist: '実行中...',
        executeDistribution: '分配を実行',
        fundCreatedMsg: 'ファンドを作成しました',
        fundUpdatedMsg: 'ファンドを更新しました',
        pageDeleted: 'ページを削除しました',
        contactDeleted: '削除しました',
        userUpdatedMsg: 'ユーザーを更新しました',
        userDeletedMsg: 'ユーザーを削除しました',
        newPageCreate: '新規ページ作成',
        slugLabel: 'スラッグ (URL)',
        titleLabel: 'タイトル',
        createPageBtn: 'ページを作成',
        noKycSubmissions: 'KYC申請はありません',
        viewDoc: '書類確認',
        approveBtn: '承認',
        rejectBtn: '却下',
        kycRejectTitle: 'KYC却下',
        kycRejectConfirm: '{{name}} のKYC申請を却下しますか？',
        kycStatus: 'KYC状態',
        unverifiedLabel: '未認証',
        verifiedBadge: '認証済',
        pendingBadge: '確認中',
        unverifiedBadge: '未認証',
        calcFailed: '計算に失敗しました',
        execFailed: '実行に失敗しました',
        enterFundAndRevenue: 'ファンドと総収益を入力してください',
        docInfo: '書類: {{type}} | 提出日: {{date}}'
      },
      common: {
        loading: '読み込み中...',
        error: 'エラーが発生しました',
        success: '成功',
        cancel: 'キャンセル',
        confirm: '確認',
        save: '保存',
        delete: '削除',
        edit: '編集',
        view: '詳細',
        back: '戻る',
        next: '次へ',
        currency: '¥'
      },
      translate: {
        enterText: '翻訳するテキストを入力してください',
        success: '翻訳しました',
        error: '翻訳に失敗しました',
        translating: '翻訳中...',
        label: '自動翻訳'
      },
      session: {
        warningTitle: 'セッション期限切れ',
        warningMessage: 'セキュリティのため、まもなく自動ログアウトされます。続行しますか？',
        extend: 'セッションを延長',
        logout: 'ログアウト'
      },
      br: {
        title: 'BR投資管理',
        subtitle: 'ブラジル投資信託・FIIs 統合管理',
        refresh: '更新',
        addHolding: '資産を追加',
        ticker: '銘柄コード',
        assetType: '種別',
        quantity: '数量',
        avgPrice: '平均取得価格',
        currentPrice: '現在価格',
        valueBRL: '評価額(BRL)',
        valueJPY: '評価額(JPY)',
        pnl: '損益率',
        monthlyDiv: '月間配当',
        annualDiv: '年間配当',
        portfolioYield: 'ポートフォリオ利回り',
        fxRates: '為替レート',
        totalValue: '総評価額',
        totalInvested: '購入合計',
        pnlAmount: '損益金額',
        risk: 'リスク',
        sector: 'セクター',
        notes: 'メモ',
        type: '種別',
        qty: '数量',
        edit: '編集',
        total: '合計',
        noHoldings: '保有資産がありません',
        lastUpdate: '最終更新',
        fillRequired: '銘柄・数量・取得価格を入力してください',
        added: '資産を追加しました',
        addFailed: '追加に失敗しました',
        updated: '更新しました',
        updateFailed: '更新に失敗しました',
        deleted: '削除しました',
        deleteFailed: '削除に失敗しました',
        addTransaction: 'ランサメント追加',
        buy: '購入',
        sell: '売却',
        asset: '銘柄',
        selectAsset: '選択',
        b3Search: 'B3検索',
        b3SearchAction: 'から検索',
        b3NotFound: 'B3で銘柄が見つかりません',
        b3ScanComplete: '銘柄をB3から登録しました',
        autoDetected: '自動判定',
        purchaseDate: '購入日',
        priceR$: '価格 (R$)',
        otherCosts: 'その他コスト',
        optional: '任意',
        totalValue2: '合計金額',
        cancel: 'キャンセル',
        merged: '合算しました',
        transactionHistory: '取引履歴',
        noTransactions: '取引履歴なし',
        txDetail: '取引明細',
        txTimeline: '取引タイムライン',
        cumQty: '累計',
        qty: '口',
        loadMore: 'もっと読み込む',
        date: '日付',
        txType: '取引種別',
        amount: '金額',
        change: '変動',
        source: 'ソース',
        tabs: {
          portfolio: 'ポートフォリオ',
          analysis: '分析',
          dividends: '配当管理',
          screening: '高配当スクリーニング',
        },
        profile: {
          title: '投資家プロフィール (B3)',
          name: '投資家名',
          broker: '証券会社',
          saved: 'プロフィールを保存しました',
          saveFailed: '保存に失敗しました',
        },
        charts: {
          byType: '資産種別',
          bySector: 'セクター別',
        },
        dividend: {
          title: '配当入金記録',
          add: '手動追加',
          added: '配当を記録しました',
          none: '配当記録なし',
          monthlyChart: '月次配当推移',
          autoSync: '配当自動取得',
          synced: 'B3から配当を取得',
          newRecords: '件の新規配当',
          syncFailed: '配当取得に失敗しました',
          lastSync: '最終同期',
          perUnit: '単価',
          manual: '手動',
        },
        screening: {
          title: '高配当FIIスクリーニング',
          filter: '銘柄検索',
          held: '保有',
          owned: '保有中',
        },
        telegram: {
          title: 'Telegram アラート設定',
          botToken: 'Bot Token',
          chatId: 'Chat ID',
          enabled: 'アラート有効',
          testSend: 'テスト送信',
          testSuccess: 'テストメッセージを送信しました',
          testFailed: 'テスト送信に失敗しました',
          saved: '設定を保存しました',
          saveFailed: '保存に失敗しました',
          priceDrop: '価格急落アラート',
          priceDropPct: '急落閾値 (%)',
          yieldDrop: '利回り低下アラート',
          yieldThreshold: '利回り閾値 (%)',
          dividendCut: '配当カットアラート',
          checkInterval: 'チェック間隔 (分)',
          checkNow: '今すぐチェック',
          checking: 'チェック中...',
          alertsSent: '件のアラートを送信しました',
          noAlerts: 'アラート条件に該当なし',
          history: 'アラート履歴',
          noHistory: '履歴なし',
          howTo: 'BotFatherで/newbotを実行してTokenを取得',
          howToChatId: 'Botにメッセージ送信後、Chat IDを取得'
        }
      },
      contract: {
        title: '電子契約証明',
        subtitle: '金銭消費貸借契約書 管理',
        newContract: '新規契約作成',
        editContract: '契約編集',
        lender: '貸主',
        borrower: '借主',
        lenderShort: '貸主',
        borrowerShort: '借主',
        name: '氏名',
        companyName: '会社名',
        nationality: '国籍',
        address: '住所',
        representative: '代表者',
        terms: '契約条件',
        amount: '貸付金額',
        interestMonthly: '月利',
        termMonths: '契約期間（月）',
        installments: '分割回数',
        lateFee: '遅延損害金',
        contractDate: '契約日',
        jurisdiction: '管轄裁判所',
        purpose: '使途',
        signatures: '電子署名',
        signNow: '署名する',
        signAs: '署名者:',
        signed: '署名済',
        unsigned: '未署名',
        save: '保存',
        saved: '保存しました',
        saveFailed: '保存に失敗しました',
        cancel: 'キャンセル',
        edit: '編集',
        delete: '削除',
        deleted: '削除しました',
        deleteFailed: '削除に失敗しました',
        deleteConfirm: '契約書を削除しますか？',
        deleteWarning: 'この操作は取り消せません。契約書と署名データが完全に削除されます。',
        signFailed: '署名に失敗しました',
        noContracts: '契約書がありません',
        createFirst: '最初の契約書を作成',
        statusDraft: '下書き',
        statusPending: '署名待ち',
        statusSigned: '締結済',
        email: 'メールアドレス',
        whatsapp: 'WhatsApp番号',
        whatsappRequest: 'WhatsAppで送信',
        whatsappSent: '送信しました',
        whatsappFailed: 'WhatsApp送信に失敗しました',
        requestSent: '依頼送信日',
        lockedNotice: 'この契約は双方の署名が完了しているため、編集できません（締結済み）。',
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: 'Home',
        funds: 'Funds',
        dashboard: 'Dashboard',
        login: 'Login',
        register: 'Sign Up Free',
        logout: 'Logout',
        myPage: 'My Page',
        admin: 'Admin Panel'
      },
      hero: {
        title: 'Invest in Real Estate — Simple, Transparent, Global.',
        subtitle: 'Presage REIT\'s Control is a global investment platform that visualizes all investments, distributions, and management.',
        cta1: 'Start Free',
        cta2: 'View Funds',
        cta3: 'Watch Demo'
      },
      steps: {
        title: 'Start Investing in 3 Steps',
        step1: { title: 'Register', desc: 'Create your account with simple information' },
        step2: { title: 'Verify Identity', desc: 'Complete KYC verification online' },
        step3: { title: 'Start Investing', desc: 'Choose your preferred fund and invest' }
      },
      features: {
        title: 'Why Choose Us',
        transparency: { title: 'Distribution Transparency', desc: 'View the exact formula for revenue, costs, and net profit' },
        global: { title: 'Global Support', desc: 'Multi-language and international transfers supported' },
        dashboard: { title: 'Decision Support UI', desc: 'Real-time analysis on a single dashboard' },
        security: { title: 'Complete Security', desc: 'KYC, encryption, audit logs, AI fraud detection' }
      },
      funds: {
        title: 'Fund List',
        viewAll: 'View All',
        minInvestment: 'Min Investment',
        targetYield: 'Target Yield',
        actualYield: 'Actual Yield',
        riskLevel: 'Risk',
        totalRaised: 'Total Raised',
        invest: 'Invest',
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        guaranteed: 'Interest Guaranteed',
        details: 'View Details',
        investNow: 'Invest Now',
        backToFunds: 'Back to Funds',
        fundInfo: 'Fund Information',
        propertyType: 'Property Type',
        location: 'Location',
        status: 'Status',
        guaranteeInfo: 'Guarantee Information',
        guaranteeType: 'Type',
        guaranteeRate: 'Guaranteed Rate',
        guaranteePeriod: 'Period',
        guaranteeConditions: 'Conditions',
        guaranteeFull: 'Full Guarantee',
        guaranteePartial: 'Partial Guarantee',
        guaranteeNone: 'None',
        riskWarning: 'Risk Disclosure',
        riskWarningText: 'Investing involves risks. Principal is not guaranteed. Please make investment decisions at your own responsibility.',
        searchPlaceholder: 'Search funds...',
        allRisks: 'All Risks',
        sortBy: 'Sort By',
        riskLevelFilter: 'Risk Level'
      },
      distribution: {
        title: 'Distribution Transparency',
        subtitle: 'The formula is displayed as is. Transparent investing realized.',
        grossRevenue: 'Gross Revenue',
        costs: 'Costs',
        netProfit: 'Net Profit',
        yourShare: 'Your Share',
        yourDistribution: 'Your Distribution'
      },
      transfer: {
        title: 'Transfer Methods',
        subtitle: 'Safe and low-cost international transfers',
        wise: { title: 'Wise', desc: 'Low fees, real-time exchange rates' },
        prc: { title: 'PRC Remit', desc: 'Strong in emerging market transfers' },
        note: '* Transfer fees and exchange rates are subject to each service\'s terms'
      },
      stats: {
        totalFunds: 'Total Funds',
        totalRaised: 'Total Raised',
        investors: 'Investors',
        avgYield: 'Avg. Yield',
        oku: 'B'
      },
      security: {
        title: 'Security',
        kyc: 'KYC Verification',
        encryption: 'Data Encryption',
        audit: 'Audit Logs',
        ai: 'AI Fraud Detection'
      },
      faq: {
        title: 'FAQ',
        q1: 'What is the minimum investment?',
        a1: 'It varies by fund, but you can invest from as low as ¥30,000.',
        q2: 'Is the principal guaranteed?',
        a2: 'In principle, principal is not guaranteed. However, some low-yield funds have conditional interest guarantees.',
        q3: 'When will I receive distributions?',
        a3: 'Distributions are made quarterly (March, June, September, December).',
        q4: 'How long does withdrawal take?',
        a4: 'Withdrawals are processed within 3-5 business days.'
      },
      cta: {
        title: 'Start Now',
        subtitle: 'Experience transparent investing.',
        button: 'Start Free'
      },
      dashboard: {
        title: 'Dashboard',
        totalAssets: 'Total Assets',
        totalYield: 'Yield',
        totalDistributions: 'Total Distributions',
        profitLoss: 'P&L',
        assetHistory: 'Asset History',
        distributionHistory: 'Distribution History',
        myInvestments: 'My Investments',
        noInvestments: 'No investments yet',
        startInvesting: 'Start Investing',
        rankings: 'Rankings',
        highYield: 'High Yield',
        popular: 'Popular',
        deposit: 'Deposit',
        withdraw: 'Withdraw',
        invest: 'Invest',
        man: '0K'
      },
      auth: {
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        name: 'Name',
        namePlaceholder: 'John Smith',
        language: 'Language',
        loginButton: 'Login',
        registerButton: 'Register',
        noAccount: 'Don\'t have an account?',
        hasAccount: 'Already have an account?',
        forgotPassword: 'Forgot password?'
      },
      kyc: {
        title: 'Identity Verification',
        required: 'KYC Verification Required',
        description: 'Identity verification is required for investing and withdrawals.',
        start: 'Start Verification',
        pending: 'Pending',
        verified: 'Verified',
        selectDocument: 'Select Document Type',
        passport: 'Passport',
        driverLicense: 'Driver\'s License',
        idCard: 'ID Card / Residence Card',
        completed: 'Identity verification is complete. You can now invest in funds.',
        goToFunds: 'Go to Funds',
        stepSelect: 'Select Document',
        stepReview: 'Under Review',
        stepDone: 'Complete',
        reviewing: 'Under Review',
        reviewingDesc: 'Your documents are being reviewed. This usually takes 1-2 business days.',
        reviewingNote: 'You can check the result on your dashboard.',
        rejected: 'Verification was rejected',
        rejectedReason: 'Reason: {{reason}}',
        rejectedRetry: 'Please resubmit your documents.',
        uploadDoc: 'Upload Document',
        clickToSelect: 'Click to select a file',
        fileTypes: 'JPG, PNG, PDF (max 10MB)',
        fileTypeError: 'Only JPG, PNG, PDF files are allowed',
        fileSizeError: 'File size must be 10MB or less',
        uploadError: 'Submission failed',
        uploadSuccess: 'Document submitted. Please wait for admin review.',
        pleaseUpload: 'Please upload a document',
        notice: 'Please ensure the text on your document is clearly legible. After submission, an admin will review within 1-2 business days.',
        submitting: 'Submitting...',
        submit: 'Submit Document',
        secureComm: 'Secure encrypted connection',
        fastReview: 'Complete in 1-2 business days',
        oneTime: 'One-time process only'
      },
      contact: {
        title: 'Contact Us',
        subtitle: 'Let us know your questions or requests',
        name: 'Name',
        namePlaceholder: 'John Smith',
        email: 'Email',
        subject: 'Subject',
        subjectPlaceholder: 'Subject of your inquiry',
        message: 'Message',
        messagePlaceholder: 'Please enter your message...',
        sending: 'Sending...',
        send: 'Send',
        success: 'Your inquiry has been sent',
        error: 'Failed to send',
        doneTitle: 'Sent Successfully',
        doneMessage: 'Thank you for your inquiry.',
        doneNote: 'We will review and contact you shortly.',
        backHome: 'Back to Home'
      },
      deposit: {
        title: 'Deposit Request',
        subtitle: 'Submit a deposit request. Your balance will be updated after admin confirmation.',
        refNumber: 'Your reference number (always include this)',
        copied: 'Copied',
        fees: 'Fees',
        feesDesc: '{{percentage}}% of transfer amount (min. ¥{{minimum}})',
        bankInfo: 'Transfer Destination',
        bankName: 'Bank Name',
        refNumberLabel: 'Reference Number',
        steps: 'Transfer Steps',
        currencies: 'Supported Currencies',
        exchangeRates: 'Current Exchange Rates (Reference)',
        rateUpdated: 'Updated: {{date}}',
        rateNote: '* Rate per 1 JPY. Actual rates may vary by service.',
        warnings: 'Important Notes',
        needRegister: 'Registration is required for deposits',
        registerFree: 'Register for Free',
        requestTitle: 'Deposit Request',
        amount: 'Amount (JPY)',
        amountPlaceholder: 'e.g. 1000000',
        method: 'Deposit Method',
        methodBank: 'Bank Transfer',
        methodWise: 'Wise Transfer',
        depositorName: 'Depositor Name',
        depositorNamePlaceholder: 'Name of the person making the transfer',
        notesLabel: 'Notes',
        notesPlaceholder: 'Transfer date or other info (optional)',
        submit: 'Submit Deposit Request',
        submitting: 'Submitting...',
        success: 'Deposit request submitted',
        error: 'Failed to submit',
        history: 'Deposit History',
        noDeposits: 'No deposit history',
        statusPending: 'Pending',
        statusApproved: 'Approved',
        statusRejected: 'Rejected',
        balance: 'Balance',
        balanceDesc: 'Your balance will be updated after deposit approval',
        enterAmount: 'Please enter an amount',
        enterDepositorName: 'Please enter depositor name',
        methodInfoTitle: 'Transfer Destination Info',
        methodAccountName: 'Account Holder',
        methodAccountEmail: 'Email',
        methodAccountId: 'Account ID',
        methodCurrency: 'Currency',
        methodFee: 'Fee'
      },
      withdrawal: {
        title: 'Withdrawal Request',
        subtitle: 'Withdraw based on your portfolio value',
        available: 'Available for Withdrawal',
        selectAmount: 'Select Amount and Method',
        amount: 'Withdrawal Amount (JPY)',
        minAmount: 'Minimum: ¥10,000',
        method: 'Withdrawal Method',
        currency: 'Receiving Currency',
        calculating: 'Calculating...',
        calculate: 'Calculate',
        confirm: 'Withdrawal Confirmation',
        amountLabel: 'Amount',
        fee: 'Fee ({{percentage}}%)',
        afterFee: 'After Fee',
        exchangeRate: 'Exchange Rate',
        expectedAmount: 'Expected Amount',
        bankInfo: 'Bank Account Information',
        bankName: 'Bank Name *',
        bankNamePlaceholder: 'Bank of America',
        accountName: 'Account Holder *',
        accountNamePlaceholder: 'JOHN SMITH',
        accountNumber: 'Account Number *',
        swiftCode: 'SWIFT/BIC Code',
        notes: 'Notes (Branch, etc.)',
        notesPlaceholder: 'Branch name, account type',
        submitting: 'Submitting...',
        submitBtn: 'Submit Withdrawal',
        doneTitle: 'Withdrawal Submitted',
        doneMessage: 'Your withdrawal request has been received.',
        doneNote: 'Processing takes 3-5 business days.',
        backDashboard: 'Back to Dashboard',
        history: 'Withdrawal History',
        needKyc: 'KYC Verification Required',
        needKycDesc: 'Identity verification is required for withdrawals.',
        startKyc: 'Start Verification',
        inputError: 'Please enter withdrawal amount',
        calcError: 'Calculation failed',
        bankError: 'Please enter bank information',
        success: 'Withdrawal request submitted',
        error: 'Request failed',
        statusPending: 'Pending',
        statusApproved: 'Approved',
        statusCompleted: 'Completed',
        statusRejected: 'Rejected',
        wiseOption: 'Wise (Fee {{fee}}%)',
        prcOption: 'PRC Remit (Fee {{fee}}%)',
        jpyOption: 'JPY (Japanese Yen)',
        usdOption: 'USD (US Dollar)',
        brlOption: 'BRL (Brazilian Real)',
        eurOption: 'EUR (Euro)',
        gbpOption: 'GBP (British Pound)',
        feeLabel: 'Fee ({{percentage}}%)',
        swiftLabel: 'SWIFT/BIC Code',
        completedText: 'Your withdrawal request has been received.',
        processingText: 'Processing takes 3-5 business days.'
      },
      content: {
        notFound: 'Page not found',
        backHome: 'Back to Home',
        back: 'Back',
        lastUpdated: 'Last updated: {{date}}'
      },
      footer: {
        terms: 'Terms of Service',
        privacy: 'Privacy Policy',
        contact: 'Contact',
        company: 'About Us',
        risk: 'Risk Disclosure',
        copyright: '© 2024 Presage Ltd. All rights reserved.'
      },
      admin: {
        dashboard: 'Admin Dashboard',
        users: 'User Management',
        funds: 'Fund Management',
        pages: 'Page Management',
        menus: 'Menu Management',
        menuCat: 'Header Menu',
        contacts: 'Contacts',
        withdrawals: 'Withdrawals',
        deposits: 'Deposits',
        distributions: 'Distributions',
        kyc: 'KYC Review',
        auditLogs: 'Audit Logs',
        noContacts: 'No contacts',
        noUsers: 'No matching users',
        noLogs: 'No logs',
        createUser: 'Create User',
        userDetail: 'User Details',
        resetPassword: 'Reset Password',
        searchUser: 'Search by name or email...',
        allRoles: 'All Roles',
        allKyc: 'All KYC',
        allStatus: 'All Status',
        active: 'Active',
        inactive: 'Inactive',
        roleAdmin: 'Admin',
        roleUser: 'User',
        verified: 'Verified',
        pending: 'Pending',
        notStarted: 'Not Started',
        rejected: 'Rejected',
        name: 'Name',
        email: 'Email',
        role: 'Role',
        kycLabel: 'KYC',
        status: 'Status',
        registeredAt: 'Registered',
        actions: 'Actions',
        deleteUser: 'Delete User',
        deleteConfirm: ' will be deleted. This action cannot be undone.',
        investCount: 'Investments',
        totalInvested: 'Total Invested',
        totalDist: 'Total Distributions',
        investments: 'Investments',
        distHistory: 'Distribution History',
        withdrawHistory: 'Withdrawal History',
        noTransactions: 'No transaction history',
        fund: 'Fund',
        amount: 'Amount',
        currentValue: 'Current Value',
        distAmount: 'Distribution',
        date: 'Date',
        method: 'Method',
        passwordLabel: 'Password (8+ characters)',
        creating: 'Creating...',
        create: 'Create',
        newPassword: 'New Password (8+ characters)',
        resetting: 'Resetting...',
        reset: 'Reset',
        resetDesc: '\'s password will be reset.',
        all: 'All',
        authCat: 'Auth',
        fundCat: 'Fund',
        userCat: 'User',
        kycCat: 'KYC',
        withdrawCat: 'Withdrawal',
        depositCat: 'Deposit',
        distCat: 'Distribution',
        datetime: 'Date/Time',
        category: 'Category',
        action: 'Action',
        executor: 'Executed By',
        details: 'Details',
        items: 'items',
        settingsCat: 'Settings',
        fetchError: 'Failed to fetch data',
        userFetchError: 'Failed to fetch user information',
        fillAllFields: 'Please fill all fields',
        passwordMin: 'Password must be at least 8 characters',
        userCreated: 'User created',
        createFailed: 'Creation failed',
        passwordResetDone: 'Password has been reset',
        resetFailed: 'Reset failed',
        operationFailed: 'Operation failed',
        saved: 'Saved',
        saveFailed: 'Failed to save',
        logoUploaded: 'Logo uploaded',
        uploadFailed: 'Upload failed',
        logoDeleted: 'Logo deleted',
        deleteFailed: 'Failed to delete',
        companySaved: 'Company info saved',
        photoUploaded: 'Photo uploaded',
        photoDeleted: 'Photo deleted',
        menuSaved: 'Menu saved',
        slugRequired: 'Slug and title are required',
        pageCreated: 'Page created',
        contactReplied: 'Reply sent',
        replyFailed: 'Reply failed',
        noteSaved: 'Note saved',
        statusUpdated: 'Status updated',
        updateFailed: 'Update failed',
        depositApproved: 'Deposit approved',
        depositRejected: 'Deposit rejected',
        depositMethodsSaved: 'Deposit methods saved',
        fundSaved: 'Fund saved',
        fundDeleted: 'Fund deleted',
        fundDeleteConfirm: 'Delete this fund?',
        kycApproved: 'KYC approved',
        kycRejected: 'KYC rejected',
        distributionExecuted: 'Distribution executed',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy',
        risk: 'Risk Disclosure',
        about: 'About Us',
        statusNew: 'New',
        statusRead: 'Read',
        statusReplied: 'Replied',
        statusPendingW: 'Pending',
        statusApprovedW: 'Approved',
        statusCompleted: 'Completed',
        statusRejectedW: 'Rejected',
        statusPendingD: 'Pending',
        statusApprovedD: 'Approved',
        statusRejectedD: 'Rejected',
        kycPending: 'Pending',
        kycApprovedLabel: 'Approved',
        kycRejectedLabel: 'Rejected',
        docPassport: 'Passport',
        docLicense: "Driver's License",
        docIdCard: 'ID Card',
        detailTitle: 'Details',
        editTitle: 'Edit',
        resetPwTitle: 'Reset Password',
        disableTitle: 'Disable',
        enableTitle: 'Enable',
        deleteTitle: 'Delete',
        fundActive: 'Active',
        guaranteeFull: 'Full Guarantee',
        guaranteePartial: 'Partial Guarantee',
        guaranteeExists: 'Guaranteed',
        logoChange: 'Change',
        logoUpload: 'Upload',
        depositMethodsTitle: 'Deposit Method Settings',
        depositMethodsDesc: 'Configure transfer destination info shown to users',
        saveDepositMethods: 'Save Deposit Methods',
        saving: 'Saving...',
        noDeposits: 'No deposit requests',
        noWithdrawals: 'No withdrawal requests',
        distExecuted: 'Executed',
        kycDocError: 'Document Error',
        newFund: 'Create New Fund',
        editFund: 'Edit Fund',
        withdrawalAccepted: 'Withdrawal request accepted',
        withdrawalProcessing: 'Processing takes 3-5 business days',
        accountName: 'Account Holder',
        accountEmail: 'Email',
        accountId: 'Account ID / Number',
        currency: 'Currency',
        feeRate: 'Fee Rate (%)',
        notes: 'Notes / Instructions',
        auditActions: {
          user_login: 'Login',
          fund_created: 'Fund Created',
          fund_updated: 'Fund Updated',
          fund_deleted: 'Fund Deleted',
          user_updated: 'User Updated',
          user_deleted: 'User Deleted',
          withdrawal_approved: 'Withdrawal Approved',
          withdrawal_rejected: 'Withdrawal Rejected',
          withdrawal_completed: 'Withdrawal Completed',
          withdrawal_pending: 'Withdrawal Pending',
          distribution_executed: 'Distribution Executed',
          deposit_approved: 'Deposit Approved',
          deposit_rejected: 'Deposit Rejected',
          deposit_methods_updated: 'Deposit Methods Updated',
          kyc_approved: 'KYC Approved',
          kyc_rejected: 'KYC Rejected',
          user_created: 'User Created',
          password_reset: 'Password Reset',
          status_toggled: 'Status Changed'
        },
        editUser: 'Edit User',
        basicInfo: 'Basic Info',
        targetYieldLabel: 'Target Yield (%)',
        actualYieldLabel: 'Actual Yield (%)',
        minInvestLabel: 'Min Investment (JPY)',
        riskLevelLabel: 'Risk Level',
        riskLow: 'Low',
        riskMedium: 'Medium',
        riskHigh: 'High',
        propertyTypeLabel: 'Property Type',
        locationLabel: 'Location',
        fundStatusLabel: 'Status',
        statusPublic: 'Public',
        statusPrivate: 'Private',
        statusClosed: 'Closed',
        interestGuarantee: 'Interest Guaranteed',
        guaranteeSettings: 'Guarantee Settings',
        guaranteeTypeLabel: 'Guarantee Type',
        guaranteeNoneOpt: 'None',
        guaranteePartialOpt: 'Partial',
        guaranteeFullOpt: 'Full',
        guaranteeRateLabel: 'Guaranteed Rate (%)',
        guaranteePeriodLabel: 'Guarantee Period',
        guaranteeConditionsLabel: 'Guarantee Conditions',
        guaranteeConditionsPlaceholder: 'Enter guarantee conditions and notes...',
        exampleYield: 'e.g. 5.0',
        examplePeriod: 'e.g. 2025/01 - 2027/12',
        imageUrl: 'Image URL',
        fundNameLabel: 'Fund Name',
        descriptionLabel: 'Description',
        newDistribution: 'Create Distribution',
        selectFund: 'Select Fund',
        distributionDate: 'Distribution Date',
        grossRevenue: 'Gross Revenue (JPY)',
        costsLabel: 'Costs (JPY)',
        memoLabel: 'Notes',
        optional: 'Optional',
        calculatingDist: 'Calculating...',
        previewDistribution: 'Preview Distribution',
        distributionPreview: 'Distribution Preview',
        previewFund: 'Fund:',
        previewRevenue: 'Revenue:',
        previewCosts: 'Costs:',
        previewNetProfit: 'Net Profit:',
        previewInvestors: 'Investors:',
        peopleSuffix: '',
        previewTotal: 'Total Distribution:',
        investorBreakdown: 'Distribution by Investor:',
        executingDist: 'Executing...',
        executeDistribution: 'Execute Distribution',
        fundCreatedMsg: 'Fund created',
        fundUpdatedMsg: 'Fund updated',
        pageDeleted: 'Page deleted',
        contactDeleted: 'Deleted',
        userUpdatedMsg: 'User updated',
        userDeletedMsg: 'User deleted',
        newPageCreate: 'Create New Page',
        slugLabel: 'Slug (URL)',
        titleLabel: 'Title',
        createPageBtn: 'Create Page',
        noKycSubmissions: 'No KYC submissions',
        viewDoc: 'View Document',
        approveBtn: 'Approve',
        rejectBtn: 'Reject',
        kycRejectTitle: 'Reject KYC',
        kycRejectConfirm: 'Reject KYC for {{name}}?',
        kycStatus: 'KYC Status',
        unverifiedLabel: 'Unverified',
        verifiedBadge: 'Verified',
        pendingBadge: 'Pending',
        unverifiedBadge: 'Unverified',
        calcFailed: 'Calculation failed',
        execFailed: 'Execution failed',
        enterFundAndRevenue: 'Please enter fund and revenue',
        docInfo: 'Doc: {{type}} | Submitted: {{date}}'
      },
      common: {
        loading: 'Loading...',
        error: 'An error occurred',
        success: 'Success',
        cancel: 'Cancel',
        confirm: 'Confirm',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        view: 'Details',
        back: 'Back',
        next: 'Next',
        currency: '¥'
      },
      translate: {
        enterText: 'Please enter text to translate',
        success: 'Translated',
        error: 'Translation failed',
        translating: 'Translating...',
        label: 'Auto Translate'
      },
      session: {
        warningTitle: 'Session Expiring',
        warningMessage: 'For security, you will be logged out soon. Would you like to continue?',
        extend: 'Extend Session',
        logout: 'Logout'
      },
      br: {
        title: 'BR Investment',
        subtitle: 'Brazilian FIIs & Investment Management',
        refresh: 'Refresh',
        addHolding: 'Add Holding',
        ticker: 'Ticker',
        assetType: 'Type',
        quantity: 'Quantity',
        avgPrice: 'Avg Price',
        currentPrice: 'Current Price',
        valueBRL: 'Value (BRL)',
        valueJPY: 'Value (JPY)',
        pnl: 'P&L',
        monthlyDiv: 'Monthly Div',
        annualDiv: 'Annual Div',
        portfolioYield: 'Portfolio Yield',
        fxRates: 'FX Rates',
        totalValue: 'Total Value',
        totalInvested: 'Total Invested',
        pnlAmount: 'P&L Amount',
        risk: 'Risk',
        sector: 'Sector',
        notes: 'Notes',
        type: 'Type',
        qty: 'Qty',
        edit: 'Edit',
        total: 'Total',
        noHoldings: 'No holdings yet',
        lastUpdate: 'Last update',
        fillRequired: 'Please enter ticker, quantity and price',
        added: 'Holding added',
        addFailed: 'Failed to add',
        updated: 'Updated',
        updateFailed: 'Update failed',
        deleted: 'Deleted',
        deleteFailed: 'Delete failed',
        addTransaction: 'Add Transaction',
        buy: 'Buy',
        sell: 'Sell',
        asset: 'Asset',
        selectAsset: 'Select',
        b3Search: 'B3 Search',
        b3SearchAction: ' search for',
        b3NotFound: 'Ticker not found on B3',
        b3ScanComplete: 'tickers synced from B3',
        autoDetected: 'Auto-detected',
        purchaseDate: 'Purchase Date',
        priceR$: 'Price (R$)',
        otherCosts: 'Other Costs',
        optional: 'Optional',
        totalValue2: 'Total Value',
        cancel: 'Cancel',
        merged: 'Merged',
        transactionHistory: 'Transaction History',
        noTransactions: 'No transactions yet',
        txDetail: 'Transaction Detail',
        txTimeline: 'Transaction Timeline',
        cumQty: 'Cum.',
        qty: 'units',
        loadMore: 'Load more',
        date: 'Date',
        txType: 'Type',
        amount: 'Amount',
        change: 'Change',
        tabs: {
          portfolio: 'Portfolio',
          analysis: 'Analysis',
          dividends: 'Dividends',
          screening: 'Screening',
        },
        profile: {
          title: 'Investor Profile (B3)',
          name: 'Investor Name',
          broker: 'Broker',
          saved: 'Profile saved',
          saveFailed: 'Save failed',
        },
        charts: {
          byType: 'By Asset Type',
          bySector: 'By Sector',
        },
        dividend: {
          title: 'Dividend Records',
          add: 'Manual Add',
          added: 'Dividend recorded',
          none: 'No dividend records',
          monthlyChart: 'Monthly Dividend Trend',
          autoSync: 'Auto Sync',
          synced: 'Dividends synced from B3',
          newRecords: 'new record(s)',
          syncFailed: 'Dividend sync failed',
          lastSync: 'Last sync',
          perUnit: 'Per Unit',
          manual: 'Manual',
        },
        screening: {
          title: 'High Dividend FII Screening',
          filter: 'Search ticker',
          held: 'Held',
          owned: 'Owned',
        },
        telegram: {
          title: 'Telegram Alert Settings',
          botToken: 'Bot Token',
          chatId: 'Chat ID',
          enabled: 'Alerts Enabled',
          testSend: 'Send Test',
          testSuccess: 'Test message sent',
          testFailed: 'Test send failed',
          saved: 'Settings saved',
          saveFailed: 'Save failed',
          priceDrop: 'Price Crash Alert',
          priceDropPct: 'Drop Threshold (%)',
          yieldDrop: 'Low Yield Alert',
          yieldThreshold: 'Yield Threshold (%)',
          dividendCut: 'Dividend Cut Alert',
          checkInterval: 'Check Interval (min)',
          checkNow: 'Check Now',
          checking: 'Checking...',
          alertsSent: 'alert(s) sent',
          noAlerts: 'No alerts triggered',
          history: 'Alert History',
          noHistory: 'No history',
          howTo: 'Run /newbot in BotFather to get Token',
          howToChatId: 'Send a message to the bot, then get Chat ID'
        }
      },
      contract: {
        title: 'Digital Contracts',
        subtitle: 'Loan Agreement Management',
        newContract: 'New Contract',
        editContract: 'Edit Contract',
        lender: 'Lender',
        borrower: 'Borrower',
        lenderShort: 'Lender',
        borrowerShort: 'Borrower',
        name: 'Name',
        companyName: 'Company Name',
        nationality: 'Nationality',
        address: 'Address',
        representative: 'Representative',
        terms: 'Contract Terms',
        amount: 'Loan Amount',
        interestMonthly: 'Monthly Interest',
        termMonths: 'Term (months)',
        installments: 'Installments',
        lateFee: 'Late Fee',
        contractDate: 'Contract Date',
        jurisdiction: 'Jurisdiction',
        purpose: 'Purpose',
        signatures: 'Electronic Signatures',
        signNow: 'Sign Now',
        signAs: 'Signing as:',
        signed: 'Signed',
        unsigned: 'Unsigned',
        save: 'Save',
        saved: 'Saved',
        saveFailed: 'Save failed',
        cancel: 'Cancel',
        edit: 'Edit',
        delete: 'Delete',
        deleted: 'Deleted',
        deleteFailed: 'Delete failed',
        deleteConfirm: 'Delete this contract?',
        deleteWarning: 'This action cannot be undone. The contract and all signature data will be permanently deleted.',
        signFailed: 'Signing failed',
        noContracts: 'No contracts yet',
        createFirst: 'Create your first contract',
        statusDraft: 'Draft',
        statusPending: 'Pending Signatures',
        statusSigned: 'Signed',
        email: 'Email',
        whatsapp: 'WhatsApp',
        whatsappRequest: 'Send via WhatsApp',
        whatsappSent: 'Sent',
        whatsappFailed: 'Failed to send WhatsApp',
        requestSent: 'Request sent',
        lockedNotice: 'This contract is fully signed by both parties and can no longer be edited.',
      }
    }
  },
  pt: {
    translation: {
      nav: {
        home: 'Início',
        funds: 'Fundos',
        dashboard: 'Painel',
        login: 'Entrar',
        register: 'Cadastre-se Grátis',
        logout: 'Sair',
        myPage: 'Minha Página',
        admin: 'Painel Admin'
      },
      hero: {
        title: 'Invista em imóveis com transparência total.',
        subtitle: 'Presage REIT\'s Control é uma plataforma global de investimento que visualiza todos os investimentos, distribuições e gestão.',
        cta1: 'Comece Grátis',
        cta2: 'Ver Fundos',
        cta3: 'Ver Demo'
      },
      steps: {
        title: 'Comece a Investir em 3 Passos',
        step1: { title: 'Registrar', desc: 'Crie sua conta com informações simples' },
        step2: { title: 'Verificar Identidade', desc: 'Complete a verificação KYC online' },
        step3: { title: 'Comece a Investir', desc: 'Escolha seu fundo preferido e invista' }
      },
      features: {
        title: 'Por que nos escolher',
        transparency: { title: 'Transparência na Distribuição', desc: 'Veja a fórmula exata de receita, custos e lucro líquido' },
        global: { title: 'Suporte Global', desc: 'Multi-idioma e transferências internacionais suportadas' },
        dashboard: { title: 'UI de Apoio à Decisão', desc: 'Análise em tempo real em um único painel' },
        security: { title: 'Segurança Completa', desc: 'KYC, criptografia, logs de auditoria, detecção de fraude IA' }
      },
      funds: {
        title: 'Lista de Fundos',
        viewAll: 'Ver Todos',
        minInvestment: 'Investimento Mín.',
        targetYield: 'Rendimento Alvo',
        actualYield: 'Rendimento Real',
        riskLevel: 'Risco',
        totalRaised: 'Total Captado',
        invest: 'Investir',
        low: 'Baixo',
        medium: 'Médio',
        high: 'Alto',
        guaranteed: 'Juros Garantidos',
        details: 'Ver Detalhes',
        investNow: 'Investir Agora',
        backToFunds: 'Voltar aos Fundos',
        fundInfo: 'Informações do Fundo',
        propertyType: 'Tipo de Imóvel',
        location: 'Localização',
        status: 'Status',
        guaranteeInfo: 'Informações de Garantia',
        guaranteeType: 'Tipo',
        guaranteeRate: 'Taxa Garantida',
        guaranteePeriod: 'Período',
        guaranteeConditions: 'Condições',
        guaranteeFull: 'Garantia Total',
        guaranteePartial: 'Garantia Parcial',
        guaranteeNone: 'Nenhuma',
        riskWarning: 'Aviso de Risco',
        riskWarningText: 'Investir envolve riscos. O principal não é garantido. Tome decisões de investimento por sua própria conta e risco.',
        searchPlaceholder: 'Buscar fundos...',
        allRisks: 'Todos os Riscos',
        sortBy: 'Ordenar por',
        riskLevelFilter: 'Nível de Risco'
      },
      distribution: {
        title: 'Transparência na Distribuição',
        subtitle: 'A fórmula é exibida como está. Investimento transparente realizado.',
        grossRevenue: 'Receita Bruta',
        costs: 'Custos',
        netProfit: 'Lucro Líquido',
        yourShare: 'Sua Participação',
        yourDistribution: 'Sua Distribuição'
      },
      transfer: {
        title: 'Métodos de Transferência',
        subtitle: 'Transferências internacionais seguras e de baixo custo',
        wise: { title: 'Wise', desc: 'Taxas baixas, câmbio em tempo real' },
        prc: { title: 'PRC Remit', desc: 'Forte em transferências para mercados emergentes' },
        note: '* Taxas de transferência e câmbio estão sujeitas aos termos de cada serviço'
      },
      stats: {
        totalFunds: 'Total de Fundos',
        totalRaised: 'Total Captado',
        investors: 'Investidores',
        avgYield: 'Rend. Médio',
        oku: 'B'
      },
      security: {
        title: 'Segurança',
        kyc: 'Verificação KYC',
        encryption: 'Criptografia de Dados',
        audit: 'Logs de Auditoria',
        ai: 'Detecção de Fraude IA'
      },
      faq: {
        title: 'Perguntas Frequentes',
        q1: 'Qual é o investimento mínimo?',
        a1: 'Varia por fundo, mas você pode investir a partir de ¥30.000.',
        q2: 'O principal é garantido?',
        a2: 'Em princípio, o principal não é garantido. No entanto, alguns fundos de baixo rendimento têm garantias de juros condicionais.',
        q3: 'Quando receberei as distribuições?',
        a3: 'As distribuições são feitas trimestralmente (março, junho, setembro, dezembro).',
        q4: 'Quanto tempo leva o saque?',
        a4: 'Os saques são processados em 3-5 dias úteis.'
      },
      cta: {
        title: 'Comece Agora',
        subtitle: 'Experimente o investimento transparente.',
        button: 'Comece Grátis'
      },
      dashboard: {
        title: 'Painel',
        totalAssets: 'Ativos Totais',
        totalYield: 'Rendimento',
        totalDistributions: 'Distribuições Totais',
        profitLoss: 'L&P',
        assetHistory: 'Histórico de Ativos',
        distributionHistory: 'Histórico de Distribuição',
        myInvestments: 'Meus Investimentos',
        noInvestments: 'Nenhum investimento ainda',
        startInvesting: 'Comece a Investir',
        rankings: 'Rankings',
        highYield: 'Alto Rendimento',
        popular: 'Popular',
        deposit: 'Depositar',
        withdraw: 'Sacar',
        invest: 'Investir',
        man: '0K'
      },
      auth: {
        login: 'Entrar',
        register: 'Registrar',
        email: 'E-mail',
        password: 'Senha',
        name: 'Nome',
        namePlaceholder: 'João Silva',
        language: 'Idioma',
        loginButton: 'Entrar',
        registerButton: 'Registrar',
        noAccount: 'Não tem uma conta?',
        hasAccount: 'Já tem uma conta?',
        forgotPassword: 'Esqueceu a senha?'
      },
      kyc: {
        title: 'Verificação de Identidade',
        required: 'Verificação KYC Necessária',
        description: 'A verificação de identidade é necessária para investimentos e saques.',
        start: 'Iniciar Verificação',
        pending: 'Pendente',
        verified: 'Verificado',
        selectDocument: 'Selecione o Tipo de Documento',
        passport: 'Passaporte',
        driverLicense: 'Carteira de Motorista',
        idCard: 'RG / Carteira de Residência',
        completed: 'Verificação completa. Agora você pode investir em fundos.',
        goToFunds: 'Ir para Fundos',
        stepSelect: 'Selecionar Documento',
        stepReview: 'Em Análise',
        stepDone: 'Concluído',
        reviewing: 'Em Análise',
        reviewingDesc: 'Seus documentos estão sendo analisados. Normalmente leva 1-2 dias úteis.',
        reviewingNote: 'Você pode verificar o resultado no seu painel.',
        rejected: 'Verificação foi rejeitada',
        rejectedReason: 'Motivo: {{reason}}',
        rejectedRetry: 'Por favor, reenvie seus documentos.',
        uploadDoc: 'Enviar Documento',
        clickToSelect: 'Clique para selecionar um arquivo',
        fileTypes: 'JPG, PNG, PDF (máx. 10MB)',
        fileTypeError: 'Apenas arquivos JPG, PNG, PDF são permitidos',
        fileSizeError: 'O tamanho do arquivo deve ser 10MB ou menos',
        uploadError: 'Falha no envio',
        uploadSuccess: 'Documento enviado. Aguarde a análise do administrador.',
        pleaseUpload: 'Por favor, envie um documento',
        notice: 'Certifique-se de que o texto do documento está legível. Após o envio, um administrador revisará em 1-2 dias úteis.',
        submitting: 'Enviando...',
        submit: 'Enviar Documento',
        secureComm: 'Conexão segura criptografada',
        fastReview: 'Concluído em 1-2 dias úteis',
        oneTime: 'Processo único'
      },
      contact: {
        title: 'Contato',
        subtitle: 'Envie suas perguntas ou solicitações',
        name: 'Nome',
        namePlaceholder: 'João Silva',
        email: 'E-mail',
        subject: 'Assunto',
        subjectPlaceholder: 'Assunto da sua mensagem',
        message: 'Mensagem',
        messagePlaceholder: 'Por favor, digite sua mensagem...',
        sending: 'Enviando...',
        send: 'Enviar',
        success: 'Sua mensagem foi enviada',
        error: 'Falha ao enviar',
        doneTitle: 'Enviado com Sucesso',
        doneMessage: 'Obrigado pela sua mensagem.',
        doneNote: 'Analisaremos e entraremos em contato em breve.',
        backHome: 'Voltar ao Início'
      },
      deposit: {
        title: 'Solicitação de Depósito',
        subtitle: 'Envie uma solicitação de depósito. Seu saldo será atualizado após confirmação do administrador.',
        refNumber: 'Seu número de referência (sempre inclua)',
        copied: 'Copiado',
        fees: 'Taxas',
        feesDesc: '{{percentage}}% do valor (mín. ¥{{minimum}})',
        bankInfo: 'Destino da Transferência',
        bankName: 'Nome do Banco',
        refNumberLabel: 'Número de Referência',
        steps: 'Passos da Transferência',
        currencies: 'Moedas Suportadas',
        exchangeRates: 'Taxas de Câmbio Atuais (Referência)',
        rateUpdated: 'Atualizado: {{date}}',
        rateNote: '* Taxa por 1 JPY. Taxas reais podem variar por serviço.',
        warnings: 'Notas Importantes',
        needRegister: 'Cadastro necessário para depósitos',
        registerFree: 'Cadastre-se Grátis',
        requestTitle: 'Solicitação de Depósito',
        amount: 'Valor (JPY)',
        amountPlaceholder: 'ex: 1000000',
        method: 'Método de Depósito',
        methodBank: 'Transferência Bancária',
        methodWise: 'Transferência Wise',
        depositorName: 'Nome do Depositante',
        depositorNamePlaceholder: 'Nome da pessoa que faz a transferência',
        notesLabel: 'Observações',
        notesPlaceholder: 'Data da transferência ou outras informações (opcional)',
        submit: 'Enviar Solicitação',
        submitting: 'Enviando...',
        success: 'Solicitação de depósito enviada',
        error: 'Falha ao enviar',
        history: 'Histórico de Depósitos',
        noDeposits: 'Sem histórico de depósitos',
        statusPending: 'Pendente',
        statusApproved: 'Aprovado',
        statusRejected: 'Rejeitado',
        balance: 'Saldo',
        balanceDesc: 'Seu saldo será atualizado após aprovação do depósito',
        enterAmount: 'Por favor, insira o valor',
        enterDepositorName: 'Por favor, insira o nome do depositante',
        methodInfoTitle: 'Informações de Destino',
        methodAccountName: 'Titular da Conta',
        methodAccountEmail: 'E-mail',
        methodAccountId: 'ID da Conta',
        methodCurrency: 'Moeda',
        methodFee: 'Taxa'
      },
      withdrawal: {
        title: 'Solicitação de Saque',
        subtitle: 'Saque com base no valor do seu portfólio',
        available: 'Disponível para Saque',
        selectAmount: 'Selecione Valor e Método',
        amount: 'Valor do Saque (JPY)',
        minAmount: 'Mínimo: ¥10.000',
        method: 'Método de Saque',
        currency: 'Moeda de Recebimento',
        calculating: 'Calculando...',
        calculate: 'Calcular',
        confirm: 'Confirmação do Saque',
        amountLabel: 'Valor',
        fee: 'Taxa ({{percentage}}%)',
        afterFee: 'Após Taxa',
        exchangeRate: 'Taxa de Câmbio',
        expectedAmount: 'Valor Esperado',
        bankInfo: 'Informações Bancárias',
        bankName: 'Nome do Banco *',
        bankNamePlaceholder: 'Banco do Brasil',
        accountName: 'Titular da Conta *',
        accountNamePlaceholder: 'JOÃO SILVA',
        accountNumber: 'Número da Conta *',
        swiftCode: 'Código SWIFT/BIC',
        notes: 'Observações (Agência, etc.)',
        notesPlaceholder: 'Nome da agência, tipo de conta',
        submitting: 'Enviando...',
        submitBtn: 'Solicitar Saque',
        doneTitle: 'Saque Solicitado',
        doneMessage: 'Sua solicitação de saque foi recebida.',
        doneNote: 'O processamento leva 3-5 dias úteis.',
        backDashboard: 'Voltar ao Painel',
        history: 'Histórico de Saques',
        needKyc: 'Verificação KYC Necessária',
        needKycDesc: 'Verificação de identidade necessária para saques.',
        startKyc: 'Iniciar Verificação',
        inputError: 'Por favor, insira o valor do saque',
        calcError: 'Falha no cálculo',
        bankError: 'Por favor, insira as informações bancárias',
        success: 'Solicitação de saque enviada',
        error: 'Falha na solicitação',
        statusPending: 'Pendente',
        statusApproved: 'Aprovado',
        statusCompleted: 'Concluído',
        statusRejected: 'Rejeitado',
        wiseOption: 'Wise (Taxa {{fee}}%)',
        prcOption: 'PRC Remit (Taxa {{fee}}%)',
        jpyOption: 'JPY (Iene Japonês)',
        usdOption: 'USD (Dólar Americano)',
        brlOption: 'BRL (Real Brasileiro)',
        eurOption: 'EUR (Euro)',
        gbpOption: 'GBP (Libra Esterlina)',
        feeLabel: 'Taxa ({{percentage}}%)',
        swiftLabel: 'Código SWIFT/BIC',
        completedText: 'Sua solicitação de saque foi recebida.',
        processingText: 'O processamento leva 3-5 dias úteis.'
      },
      content: {
        notFound: 'Página não encontrada',
        backHome: 'Voltar ao Início',
        back: 'Voltar',
        lastUpdated: 'Última atualização: {{date}}'
      },
      footer: {
        terms: 'Termos de Serviço',
        privacy: 'Política de Privacidade',
        contact: 'Contato',
        company: 'Sobre Nós',
        risk: 'Divulgação de Riscos',
        copyright: '© 2024 Presage Ltd. Todos os direitos reservados.'
      },
      admin: {
        dashboard: 'Painel Admin',
        users: 'Gerenciar Usuários',
        funds: 'Gerenciar Fundos',
        pages: 'Gerenciar Páginas',
        menus: 'Gerenciar Menus',
        menuCat: 'Menu de Cabeçalho',
        contacts: 'Contatos',
        withdrawals: 'Saques',
        deposits: 'Depósitos',
        distributions: 'Distribuições',
        kyc: 'Revisão KYC',
        auditLogs: 'Logs de Auditoria',
        noContacts: 'Nenhum contato',
        noUsers: 'Nenhum usuário encontrado',
        noLogs: 'Nenhum log',
        createUser: 'Criar Usuário',
        userDetail: 'Detalhes do Usuário',
        resetPassword: 'Redefinir Senha',
        searchUser: 'Buscar por nome ou e-mail...',
        allRoles: 'Todos os Papéis',
        allKyc: 'Todos KYC',
        allStatus: 'Todos Status',
        active: 'Ativo',
        inactive: 'Inativo',
        roleAdmin: 'Admin',
        roleUser: 'Usuário',
        verified: 'Verificado',
        pending: 'Pendente',
        notStarted: 'Não Iniciado',
        rejected: 'Rejeitado',
        name: 'Nome',
        email: 'E-mail',
        role: 'Papel',
        kycLabel: 'KYC',
        status: 'Status',
        registeredAt: 'Registrado',
        actions: 'Ações',
        deleteUser: 'Excluir Usuário',
        deleteConfirm: ' será excluído. Esta ação não pode ser desfeita.',
        investCount: 'Investimentos',
        totalInvested: 'Total Investido',
        totalDist: 'Total Distribuído',
        investments: 'Investimentos',
        distHistory: 'Histórico de Distribuição',
        withdrawHistory: 'Histórico de Saques',
        noTransactions: 'Sem histórico de transações',
        fund: 'Fundo',
        amount: 'Valor',
        currentValue: 'Valor Atual',
        distAmount: 'Distribuição',
        date: 'Data',
        method: 'Método',
        passwordLabel: 'Senha (8+ caracteres)',
        creating: 'Criando...',
        create: 'Criar',
        newPassword: 'Nova Senha (8+ caracteres)',
        resetting: 'Redefinindo...',
        reset: 'Redefinir',
        resetDesc: ' terá a senha redefinida.',
        all: 'Todos',
        authCat: 'Auth',
        fundCat: 'Fundo',
        userCat: 'Usuário',
        kycCat: 'KYC',
        withdrawCat: 'Saque',
        depositCat: 'Depósito',
        distCat: 'Distribuição',
        datetime: 'Data/Hora',
        category: 'Categoria',
        action: 'Ação',
        executor: 'Executado Por',
        details: 'Detalhes',
        items: 'itens',
        settingsCat: 'Configurações',
        fetchError: 'Falha ao buscar dados',
        userFetchError: 'Falha ao buscar informações do usuário',
        fillAllFields: 'Preencha todos os campos',
        passwordMin: 'A senha deve ter pelo menos 8 caracteres',
        userCreated: 'Usuário criado',
        createFailed: 'Falha na criação',
        passwordResetDone: 'Senha redefinida',
        resetFailed: 'Falha na redefinição',
        operationFailed: 'Falha na operação',
        saved: 'Salvo',
        saveFailed: 'Falha ao salvar',
        logoUploaded: 'Logo enviado',
        uploadFailed: 'Falha no envio',
        logoDeleted: 'Logo excluído',
        deleteFailed: 'Falha ao excluir',
        companySaved: 'Informações da empresa salvas',
        photoUploaded: 'Foto enviada',
        photoDeleted: 'Foto excluída',
        menuSaved: 'Menu salvo',
        slugRequired: 'Slug e título são obrigatórios',
        pageCreated: 'Página criada',
        contactReplied: 'Resposta enviada',
        replyFailed: 'Falha ao responder',
        noteSaved: 'Nota salva',
        statusUpdated: 'Status atualizado',
        updateFailed: 'Falha na atualização',
        depositApproved: 'Depósito aprovado',
        depositRejected: 'Depósito rejeitado',
        depositMethodsSaved: 'Métodos de depósito salvos',
        fundSaved: 'Fundo salvo',
        fundDeleted: 'Fundo excluído',
        fundDeleteConfirm: 'Excluir este fundo?',
        kycApproved: 'KYC aprovado',
        kycRejected: 'KYC rejeitado',
        distributionExecuted: 'Distribuição executada',
        terms: 'Termos de Serviço',
        privacy: 'Política de Privacidade',
        risk: 'Divulgação de Riscos',
        about: 'Sobre Nós',
        statusNew: 'Novo',
        statusRead: 'Lido',
        statusReplied: 'Respondido',
        statusPendingW: 'Pendente',
        statusApprovedW: 'Aprovado',
        statusCompleted: 'Concluído',
        statusRejectedW: 'Rejeitado',
        statusPendingD: 'Pendente',
        statusApprovedD: 'Aprovado',
        statusRejectedD: 'Rejeitado',
        kycPending: 'Pendente',
        kycApprovedLabel: 'Aprovado',
        kycRejectedLabel: 'Rejeitado',
        docPassport: 'Passaporte',
        docLicense: 'Carteira de Motorista',
        docIdCard: 'RG / Carteira',
        detailTitle: 'Detalhes',
        editTitle: 'Editar',
        resetPwTitle: 'Redefinir Senha',
        disableTitle: 'Desativar',
        enableTitle: 'Ativar',
        deleteTitle: 'Excluir',
        fundActive: 'Ativo',
        guaranteeFull: 'Garantia Total',
        guaranteePartial: 'Garantia Parcial',
        guaranteeExists: 'Garantido',
        logoChange: 'Alterar',
        logoUpload: 'Enviar',
        depositMethodsTitle: 'Configurações de Método de Depósito',
        depositMethodsDesc: 'Configure as informações de destino mostradas aos usuários',
        saveDepositMethods: 'Salvar Métodos de Depósito',
        saving: 'Salvando...',
        noDeposits: 'Sem solicitações de depósito',
        noWithdrawals: 'Sem solicitações de saque',
        distExecuted: 'Executado',
        kycDocError: 'Erro no Documento',
        newFund: 'Criar Novo Fundo',
        editFund: 'Editar Fundo',
        withdrawalAccepted: 'Solicitação de saque aceita',
        withdrawalProcessing: 'Processamento leva 3-5 dias úteis',
        accountName: 'Titular da Conta',
        accountEmail: 'E-mail',
        accountId: 'ID da Conta / Número',
        currency: 'Moeda',
        feeRate: 'Taxa (%)',
        notes: 'Observações / Instruções',
        auditActions: {
          user_login: 'Login',
          fund_created: 'Fundo Criado',
          fund_updated: 'Fundo Atualizado',
          fund_deleted: 'Fundo Excluído',
          user_updated: 'Usuário Atualizado',
          user_deleted: 'Usuário Excluído',
          withdrawal_approved: 'Saque Aprovado',
          withdrawal_rejected: 'Saque Rejeitado',
          withdrawal_completed: 'Saque Concluído',
          withdrawal_pending: 'Saque Pendente',
          distribution_executed: 'Distribuição Executada',
          deposit_approved: 'Depósito Aprovado',
          deposit_rejected: 'Depósito Rejeitado',
          deposit_methods_updated: 'Métodos de Depósito Atualizados',
          kyc_approved: 'KYC Aprovado',
          kyc_rejected: 'KYC Rejeitado',
          user_created: 'Usuário Criado',
          password_reset: 'Senha Redefinida',
          status_toggled: 'Status Alterado'
        },
        editUser: 'Editar Usuário',
        basicInfo: 'Info Básica',
        targetYieldLabel: 'Rendimento Alvo (%)',
        actualYieldLabel: 'Rendimento Real (%)',
        minInvestLabel: 'Investimento Mín. (JPY)',
        riskLevelLabel: 'Nível de Risco',
        riskLow: 'Baixo',
        riskMedium: 'Médio',
        riskHigh: 'Alto',
        propertyTypeLabel: 'Tipo de Imóvel',
        locationLabel: 'Localização',
        fundStatusLabel: 'Status',
        statusPublic: 'Público',
        statusPrivate: 'Privado',
        statusClosed: 'Encerrado',
        interestGuarantee: 'Juros Garantidos',
        guaranteeSettings: 'Configurações de Garantia',
        guaranteeTypeLabel: 'Tipo de Garantia',
        guaranteeNoneOpt: 'Nenhuma',
        guaranteePartialOpt: 'Parcial',
        guaranteeFullOpt: 'Total',
        guaranteeRateLabel: 'Taxa Garantida (%)',
        guaranteePeriodLabel: 'Período de Garantia',
        guaranteeConditionsLabel: 'Condições de Garantia',
        guaranteeConditionsPlaceholder: 'Insira condições e observações...',
        exampleYield: 'ex: 5.0',
        examplePeriod: 'ex: 2025/01 - 2027/12',
        imageUrl: 'URL da Imagem',
        fundNameLabel: 'Nome do Fundo',
        descriptionLabel: 'Descrição',
        newDistribution: 'Criar Distribuição',
        selectFund: 'Selecionar Fundo',
        distributionDate: 'Data de Distribuição',
        grossRevenue: 'Receita Bruta (JPY)',
        costsLabel: 'Custos (JPY)',
        memoLabel: 'Notas',
        optional: 'Opcional',
        calculatingDist: 'Calculando...',
        previewDistribution: 'Pré-visualizar',
        distributionPreview: 'Pré-visualização',
        previewFund: 'Fundo:',
        previewRevenue: 'Receita:',
        previewCosts: 'Custos:',
        previewNetProfit: 'Lucro Líquido:',
        previewInvestors: 'Investidores:',
        peopleSuffix: '',
        previewTotal: 'Total:',
        investorBreakdown: 'Distribuição por Investidor:',
        executingDist: 'Executando...',
        executeDistribution: 'Executar Distribuição',
        fundCreatedMsg: 'Fundo criado',
        fundUpdatedMsg: 'Fundo atualizado',
        pageDeleted: 'Página excluída',
        contactDeleted: 'Excluído',
        userUpdatedMsg: 'Usuário atualizado',
        userDeletedMsg: 'Usuário excluído',
        newPageCreate: 'Criar Nova Página',
        slugLabel: 'Slug (URL)',
        titleLabel: 'Título',
        createPageBtn: 'Criar Página',
        noKycSubmissions: 'Sem submissões KYC',
        viewDoc: 'Ver Documento',
        approveBtn: 'Aprovar',
        rejectBtn: 'Rejeitar',
        kycRejectTitle: 'Rejeitar KYC',
        kycRejectConfirm: 'Rejeitar KYC de {{name}}?',
        kycStatus: 'Status KYC',
        unverifiedLabel: 'Não Verificado',
        verifiedBadge: 'Verificado',
        pendingBadge: 'Pendente',
        unverifiedBadge: 'Não Verificado',
        calcFailed: 'Falha no cálculo',
        execFailed: 'Falha na execução',
        enterFundAndRevenue: 'Insira o fundo e receita',
        docInfo: 'Doc: {{type}} | Enviado: {{date}}'
      },
      common: {
        loading: 'Carregando...',
        error: 'Ocorreu um erro',
        success: 'Sucesso',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        save: 'Salvar',
        delete: 'Excluir',
        edit: 'Editar',
        view: 'Detalhes',
        back: 'Voltar',
        next: 'Próximo',
        currency: '¥'
      },
      translate: {
        enterText: 'Por favor, insira o texto para traduzir',
        success: 'Traduzido',
        error: 'Falha na tradução',
        translating: 'Traduzindo...',
        label: 'Tradução Automática'
      },
      session: {
        warningTitle: 'Sessão Expirando',
        warningMessage: 'Por segurança, você será desconectado em breve. Deseja continuar?',
        extend: 'Estender Sessão',
        logout: 'Sair'
      },
      br: {
        title: 'Investimentos BR',
        subtitle: 'Gestão Integrada de FIIs e Investimentos',
        refresh: 'Atualizar',
        addHolding: 'Adicionar Ativo',
        ticker: 'Ticker',
        assetType: 'Tipo',
        quantity: 'Quantidade',
        avgPrice: 'Preço Médio',
        currentPrice: 'Preço Atual',
        valueBRL: 'Valor (BRL)',
        valueJPY: 'Valor (JPY)',
        pnl: 'L&P',
        monthlyDiv: 'Div Mensal',
        annualDiv: 'Div Anual',
        portfolioYield: 'Yield da Carteira',
        fxRates: 'Câmbio',
        totalValue: 'Valor Total',
        totalInvested: 'Total Investido',
        pnlAmount: 'Lucro/Prejuízo',
        risk: 'Risco',
        sector: 'Setor',
        notes: 'Notas',
        type: 'Tipo',
        qty: 'Qtd',
        edit: 'Editar',
        total: 'Total',
        noHoldings: 'Nenhum ativo ainda',
        lastUpdate: 'Última atualização',
        fillRequired: 'Insira ticker, quantidade e preço',
        added: 'Ativo adicionado',
        addFailed: 'Falha ao adicionar',
        updated: 'Atualizado',
        updateFailed: 'Falha na atualização',
        deleted: 'Excluído',
        deleteFailed: 'Falha ao excluir',
        addTransaction: 'Adicionar Lançamento',
        buy: 'Compra',
        sell: 'Venda',
        asset: 'Ativo',
        selectAsset: 'Selecionar',
        b3Search: 'Buscar B3',
        b3SearchAction: ' buscar',
        b3NotFound: 'Ticker não encontrado na B3',
        b3ScanComplete: 'tickers sincronizados da B3',
        autoDetected: 'Auto-detectado',
        purchaseDate: 'Data da compra',
        priceR$: 'Preço em R$',
        otherCosts: 'Outros custos',
        optional: 'Opcional',
        totalValue2: 'Valor total',
        cancel: 'Cancelar',
        merged: 'Consolidado',
        transactionHistory: 'Histórico de Transações',
        noTransactions: 'Nenhuma transação ainda',
        txDetail: 'Detalhe da Transação',
        txTimeline: 'Linha do Tempo',
        cumQty: 'Acum.',
        qty: 'cotas',
        loadMore: 'Carregar mais',
        date: 'Data',
        txType: 'Tipo',
        amount: 'Valor',
        change: 'Variação',
        tabs: {
          portfolio: 'Carteira',
          analysis: 'Análise',
          dividends: 'Dividendos',
          screening: 'Screening',
        },
        profile: {
          title: 'Perfil do Investidor (B3)',
          name: 'Nome do Investidor',
          broker: 'Corretora',
          saved: 'Perfil salvo',
          saveFailed: 'Falha ao salvar',
        },
        charts: {
          byType: 'Por Tipo de Ativo',
          bySector: 'Por Setor',
        },
        dividend: {
          title: 'Registro de Dividendos',
          add: 'Adicionar Manual',
          added: 'Dividendo registrado',
          none: 'Nenhum registro de dividendo',
          monthlyChart: 'Dividendos Mensais',
          autoSync: 'Sincronizar',
          synced: 'Dividendos sincronizados da B3',
          newRecords: 'novo(s) registro(s)',
          syncFailed: 'Falha na sincronização',
          lastSync: 'Última sinc',
          perUnit: 'Por Unidade',
          manual: 'Manual',
        },
        screening: {
          title: 'Screening FII Alta Rentabilidade',
          filter: 'Buscar ticker',
          held: 'Carteira',
          owned: 'Em carteira',
        },
        telegram: {
          title: 'Config Alertas Telegram',
          botToken: 'Bot Token',
          chatId: 'Chat ID',
          enabled: 'Alertas Ativos',
          testSend: 'Enviar Teste',
          testSuccess: 'Mensagem teste enviada',
          testFailed: 'Falha no envio teste',
          saved: 'Configurações salvas',
          saveFailed: 'Falha ao salvar',
          priceDrop: 'Alerta Queda de Preço',
          priceDropPct: 'Limite Queda (%)',
          yieldDrop: 'Alerta Yield Baixo',
          yieldThreshold: 'Limite Yield (%)',
          dividendCut: 'Alerta Corte Dividendo',
          checkInterval: 'Intervalo Check (min)',
          checkNow: 'Verificar Agora',
          checking: 'Verificando...',
          alertsSent: 'alerta(s) enviado(s)',
          noAlerts: 'Nenhum alerta disparado',
          history: 'Histórico Alertas',
          noHistory: 'Sem histórico',
          howTo: 'Execute /newbot no BotFather para obter Token',
          howToChatId: 'Envie mensagem ao bot e obtenha o Chat ID'
        }
      },
      contract: {
        title: 'Contratos Digitais',
        subtitle: 'Gestão de Contratos de Mútuo',
        newContract: 'Novo Contrato',
        editContract: 'Editar Contrato',
        lender: 'Mutuante',
        borrower: 'Mutuário',
        lenderShort: 'Mutuante',
        borrowerShort: 'Mutuário',
        name: 'Nome',
        companyName: 'Razão Social',
        nationality: 'Nacionalidade',
        address: 'Endereço',
        representative: 'Representante',
        terms: 'Condições do Contrato',
        amount: 'Valor do Empréstimo',
        interestMonthly: 'Juros Mensais',
        termMonths: 'Prazo (meses)',
        installments: 'Parcelas',
        lateFee: 'Multa por Atraso',
        contractDate: 'Data do Contrato',
        jurisdiction: 'Foro',
        purpose: 'Finalidade',
        signatures: 'Assinaturas Eletrônicas',
        signNow: 'Assinar Agora',
        signAs: 'Assinando como:',
        signed: 'Assinado',
        unsigned: 'Pendente',
        save: 'Salvar',
        saved: 'Salvo',
        saveFailed: 'Falha ao salvar',
        cancel: 'Cancelar',
        edit: 'Editar',
        delete: 'Excluir',
        deleted: 'Excluído',
        deleteFailed: 'Falha ao excluir',
        deleteConfirm: 'Excluir este contrato?',
        deleteWarning: 'Esta ação não pode ser desfeita. O contrato e todas as assinaturas serão permanentemente excluídos.',
        signFailed: 'Falha na assinatura',
        noContracts: 'Nenhum contrato ainda',
        createFirst: 'Crie seu primeiro contrato',
        statusDraft: 'Rascunho',
        statusPending: 'Aguardando Assinaturas',
        statusSigned: 'Assinado',
        email: 'E-mail',
        whatsapp: 'WhatsApp',
        whatsappRequest: 'Enviar por WhatsApp',
        whatsappSent: 'Enviado',
        whatsappFailed: 'Falha ao enviar WhatsApp',
        requestSent: 'Solicitação enviada',
        lockedNotice: 'Este contrato foi assinado por ambas as partes e não pode mais ser editado.',
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    lng: localStorage.getItem('i18nextLng') || 'ja',
    supportedLngs: ['ja', 'en', 'pt'],
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
